<template>
  <div id="document-place">
    <span>{{ getEntityType }}</span>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { ActionEntityId, ContactEntityId, ExpedientEntityId, InvoiceEntityId } from '@/general/entityIds'

@Component
class EntityTypeColumnTemplateComponent extends Vue {
  data: any = null

  private readonly entityTypeMap: Record<number, string> = {
    [ExpedientEntityId.EXPEDIENTS]: this.$t('entity.expedient') as string,
    [InvoiceEntityId.INVOICES]: this.$t('entity.invoice') as string,
    [ActionEntityId.CALL]: this.$t('entity.call') as string,
    [ActionEntityId.MEETING]: this.$t('entity.meeting') as string,
    [ActionEntityId.PROCEDURE]: this.$t('entity.procedure') as string,
    [ActionEntityId.OTHER]: this.$t('entity.other') as string,
    [InvoiceEntityId.CUSTOMER_INVOICES]: this.$t('entity.customer_invoice') as string,
    [InvoiceEntityId.PROVIDER_INVOICES]: this.$t('entity.provider_invoice') as string,
    [InvoiceEntityId.PROFORMA_INVOICES]: this.$t('entity.proforma_invoice') as string,
    [InvoiceEntityId.PROVISIONS]: this.$t('entity.provision') as string,
    [InvoiceEntityId.CUSTOMER_BAKDRAFTS]: this.$t('entity.customer_bankdraft') as string,
    [InvoiceEntityId.PROVIDER_BANKDRAFTS]: this.$t('entity.provider_bankdraft') as string,
    [ContactEntityId.CONTACTS]: this.$t('entity.contact') as string,
    [ActionEntityId.EMAIL]: this.$t('entity.email') as string,
    [ActionEntityId.LEXNET]: this.$t('entity.lexnet') as string,
    [InvoiceEntityId.ORDER_FORMS]: this.$t('entity.order_form') as string,
    [ActionEntityId.TASK]: this.$t('entity.task') as string,
    [ActionEntityId.GEST]: this.$t('entity.internal_management') as string
  }

  get getEntityType() {
    if (!this.data?.idEntityType) return null
    return this.entityTypeMap[this.data.idEntityType] || null
  }
}

export default EntityTypeColumnTemplateComponent
</script>
